import _ from 'lodash'

const getPathValue = (obj, path, defaultValue = undefined) => {
  return _.get(obj, path, defaultValue)
}

const setPathValue = (obj, path, value) => {
  const newObj = { ...obj }
  _.set(newObj, path, value)
  return newObj
}

const sortBySpecificArray = (sourceArray, sortTarget, valuePath) => {
  let allSortTarget = []
  const extraTarget = []

  if (Array.isArray(sortTarget)) {
    allSortTarget = JSON.parse(JSON.stringify(sortTarget))
  } else if (typeof sortTarget === 'object') {
    const { first = [], last = [] } = sortTarget
    const restSortTarget = sourceArray
      .filter((sourceItem) => {
        const sourceItemValue = valuePath ? getPathValue(sourceItem, valuePath, '') : sourceItem
        return !first.includes(sourceItemValue) && !last.includes(sourceItemValue)
      })
      .map((sourceItem) => (valuePath ? getPathValue(sourceItem, valuePath, '') : sourceItem))
      .sort((a, b) => a.localeCompare(b))
    allSortTarget = [...first, ...restSortTarget, ...last]
  }

  sourceArray.forEach((source) => {
    const sourceValue = valuePath ? getPathValue(source, valuePath, '') : source
    if (!allSortTarget.some((target) => target === sourceValue)) {
      extraTarget.push(sourceValue)
    }
  })
  const completeTarget = allSortTarget.concat(extraTarget)
  return sourceArray.sort((a, b) => {
    const aValue = valuePath ? getPathValue(a, valuePath, '') : a
    const bValue = valuePath ? getPathValue(b, valuePath, '') : b
    return completeTarget.indexOf(aValue) - completeTarget.indexOf(bValue)
  })
}

const divideBy100 = (value) => {
  if (value.toString().includes('.')) {
    const [, decimals] = value.toString().split('.')
    return parseFloat((parseFloat(value) * 100).toFixed(decimals.length + 2))
  }
  return parseFloat(value) * 100
}

export { getPathValue, setPathValue, sortBySpecificArray, divideBy100 }
